import React from 'react';
import PropTypes from 'prop-types';
import useClickOutside from 'hooks/useClickOutside';

const withClickOutside = (Component) => {
	const WithClickOutside = (props) => {
		const { outsideClickHandler, outsideParent, outsideCondition } = props;

		useClickOutside(outsideClickHandler, outsideParent, outsideCondition);

		return <Component {...props} />;
	};
	WithClickOutside.propTypes = {
		outsideClickHandler: PropTypes.func.isRequired,
		outsideParent: PropTypes.string,
		outsideCondition: PropTypes.bool,
	};
	WithClickOutside.displayName = `withClickOutside(${Component.displayName || Component.name || 'Component'})`;
	return WithClickOutside;
};

export default withClickOutside;
